/**
 * verify the email is valid or invalid
 * @param {string} email
 * @returns {boolean}
 */
export const isEmailValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
